(function () {
  if (window.__lasProduct) return;
  window.__lasProduct = true;

  function openAndScroll(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    if (target.tagName === 'DETAILS') target.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-las-jump]');
    if (!link) return;
    var id = (link.getAttribute('href') || '').replace('#', '');
    if (openAndScroll(id)) {
      e.preventDefault();
      e.stopPropagation();
      try { history.replaceState(null, '', '#' + id); } catch (err) {}
    }
  }, true);

  function fromHash() {
    var id = (location.hash || '').replace('#', '');
    if (id.indexOf('las-detail-') === 0) setTimeout(function () { openAndScroll(id); }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash); else fromHash();
})();

/* ----- Quantité : À l'unité / Lot de 2 / Lot de 3 / Lot de 4 / + avec remises par palier (ou lots de 2 : Lot de 2 / 4 / 6 / +) ----- */
(function () {
  if (window.__lasQty) return;
  window.__lasQty = true;

  function scope(el) { return el.closest('.shopify-section') || document; }
  function nativeInputs(root) { return root.querySelectorAll('input[name="quantity"]:not([data-las-qty-input])'); }
  function packOf(box) { return parseInt(box.dataset.pack, 10) || 1; }

  function tiersOf(box) {
    var s = box.dataset.lasTiers;
    if (!s) return [];
    return s.split(',').map(function (p) {
      var a = p.split(':');
      return [parseInt(a[0], 10), parseFloat(a[1])];
    });
  }
  function rateFor(box, q) {
    var r = 0;
    tiersOf(box).forEach(function (t) { if (q >= t[0]) r = t[1]; });
    return r;
  }

  function apply(box) {
    var q = parseInt(box.dataset.qty, 10) || 1;
    nativeInputs(scope(box)).forEach(function (inp) {
      if (String(inp.value) !== String(q)) {
        inp.value = q;
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function fmt(cents) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  function updatePrice(box) {
    var root = scope(box);
    var data = box.querySelector('[data-las-prices]');
    if (!data) return;
    var prices; try { prices = JSON.parse(data.textContent); } catch (e) { return; }
    var idInput = root.querySelector('form input[name="id"]');
    var vid = idInput ? idInput.value : Object.keys(prices)[0];
    var unit = prices[vid];
    if (unit == null) return;
    var q = parseInt(box.dataset.qty, 10) || 1;
    var pack = packOf(box);
    var rate = rateFor(box, q);
    var full = unit * q;
    var disc = Math.round(full * (100 - rate) / 100);
    var total = fmt(disc);
    root.querySelectorAll('product-price .price bdi').forEach(function (bdi) {
      if (bdi.textContent.trim() !== total) bdi.textContent = total;
      var holder = bdi.closest('product-price');
      var note = holder.querySelector('.las-unit-note');
      if (q > 1) {
        var html;
        var per = pack > 1 ? ' le lot de ' + pack : ' l\'unité';
        if (rate > 0) html = '<s>' + fmt(full) + '</s> <span class="las-off">-' + rate + ' %</span> soit ' + fmt(Math.round(disc / q)) + per;
        else if (pack > 1) html = 'soit ' + fmt(unit) + per;
        else html = 'soit ' + fmt(unit) + ' l\'unité';
        if (!note) { note = document.createElement('span'); note.className = 'las-unit-note'; bdi.closest('[ref="priceContainer"], div').appendChild(note); }
        if (note.dataset.h !== html) { note.innerHTML = html; note.dataset.h = html; }
      } else if (note) { note.remove(); }
    });
  }

  function labelFor(box, q) {
    var pack = packOf(box);
    var r = rateFor(box, q);
    if (pack > 1) return 'Lot de ' + (q * pack) + (r > 0 ? ' (-' + r + ' %)' : '');
    if (q === 1) return 'À l\'unité';
    return q + ' tabourets' + (r > 0 ? ' (-' + r + ' %)' : '');
  }

  function setQty(box, q, label) {
    q = Math.max(1, Math.min(99, parseInt(q, 10) || 1));
    box.dataset.qty = q;
    var lab = box.querySelector('[data-las-qty-label]');
    if (lab) lab.textContent = label || labelFor(box, q);
    apply(box);
    updatePrice(box);
  }

  function select(box, btn) {
    box.querySelectorAll('.las-qty__opt').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var setBtn = t.closest && t.closest('[data-las-qty-set]');
    var moreBtn = t.closest && t.closest('[data-las-qty-more]');
    var stepBtn = t.closest && t.closest('[data-las-qty-step]');
    var box = t.closest && t.closest('[data-las-qty]');
    if (!box) {
      var atc = t.closest && t.closest('button[type="submit"], [name="add"], .add-to-cart-button');
      if (atc) {
        var b = (scope(atc).querySelector('[data-las-qty]'));
        if (b) apply(b);
      }
      return;
    }
    var stepper = box.querySelector('[data-las-qty-stepper]');
    var input = box.querySelector('[data-las-qty-input]');
    if (setBtn) {
      select(box, setBtn);
      stepper.hidden = true;
      box.querySelector('[data-las-qty-more]').hidden = false;
      setQty(box, setBtn.dataset.lasQtySet, setBtn.dataset.label);
    } else if (moreBtn) {
      select(box, moreBtn);
      moreBtn.hidden = true;
      stepper.hidden = false;
      stepper.classList.add('is-active');
      setQty(box, input.value);
      input.focus();
    } else if (stepBtn) {
      input.value = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + parseInt(stepBtn.dataset.lasQtyStep, 10)));
      setQty(box, input.value);
    }
  }, true);

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-las-qty-input]')) {
      setQty(e.target.closest('[data-las-qty]'), e.target.value);
    }
  });

  /* Avant l'ajout au panier, et après un changement de variante, on remet la quantité et le prix */
  document.addEventListener('submit', function (e) {
    var b = scope(e.target).querySelector && scope(e.target).querySelector('[data-las-qty]');
    if (b) apply(b);
  }, true);
  new MutationObserver(function () {
    document.querySelectorAll('[data-las-qty]').forEach(function (b) {
      if (b.dataset.qty !== '1') { apply(b); updatePrice(b); }
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
